import React from 'react'
import { MySvgIcon, MySvgIconProps } from './MySvgIcon'

export type IconLockProps = MySvgIconProps & {
  className?:string
  title?: string
}

export const IconLock:React.FC<IconLockProps> = ({ ...props }) => {
  return (
    <MySvgIcon width='22px' viewBox="0 0 22 25" version="1.1" {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1280" transform="translate(-154.000000, -7773.000000)" fill="#1E3C70" fillRule="nonzero">
            <g id="lock-solid" transform="translate(154.333333, 7773.500000)">
                <path d="M19.047619,10.5 L17.9047619,10.5 L17.9047619,7.125 C17.9047619,3.196875 14.6571429,0 10.6666667,0 C6.67619048,0 3.42857143,3.196875 3.42857143,7.125 L3.42857143,10.5 L2.28571429,10.5 C1.02380952,10.5 0,11.5078125 0,12.75 L0,21.75 C0,22.9921875 1.02380952,24 2.28571429,24 L19.047619,24 C20.3095238,24 21.3333333,22.9921875 21.3333333,21.75 L21.3333333,12.75 C21.3333333,11.5078125 20.3095238,10.5 19.047619,10.5 Z M14.0952381,10.5 L7.23809524,10.5 L7.23809524,7.125 C7.23809524,5.2640625 8.77619048,3.75 10.6666667,3.75 C12.5571429,3.75 14.0952381,5.2640625 14.0952381,7.125 L14.0952381,10.5 Z" id="Shape"></path>
            </g>
        </g>
      </g>
    </MySvgIcon>
  )
}
